export const SEGMENT_VECTOR_DETAIL_FIELDS = [
  { key: "directType", label: "Тип направления", kind: "text" },
  { key: "deliveryParam", label: "Параметр доставки", kind: "text" },
  { key: "deliveryPrice", label: "Цена доставки", kind: "money" },
  { key: "totalPrice", label: "Итоговая цена", kind: "money" },
  { key: "pickupFromDoorPrice", label: "Забор от двери", kind: "money" },
  { key: "prdPriceStandard", label: "ПРД стандарт", kind: "money" },
  { key: "przPriceStandard", label: "ПРЗ стандарт", kind: "money" },
  { key: "priceWithMargin", label: "Цена с маржой", kind: "money" },
];

const hasDetailValue = (value) => value !== null && value !== undefined && value !== "";
const toSafeNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const buildSegmentVectorDetails = (vector = {}) => SEGMENT_VECTOR_DETAIL_FIELDS
  .filter(({ key }) => hasDetailValue(vector?.[key]))
  .map(({ key, label, kind }) => ({
    key,
    label,
    value: vector[key],
    kind,
  }));

export const sumSegmentVectorTotalPrice = (vectors = []) => vectors
  .reduce((sum, vector) => sum + toSafeNumber(vector?.totalPrice), 0);

export const getRouteVectorTotalPrice = (route = {}) => sumSegmentVectorTotalPrice(route?.vectors || []);
